// iOS (Safari and the native app's WKWebView) and Android Chrome don't shrink
// the layout viewport for the on-screen keyboard — they shrink and pan the
// *visual* viewport, while position:fixed overlays stay pinned to the layout
// one. When a focused field would sit under the keyboard, iOS pans the visible
// area up to reveal it and the fixed modal wrap doesn't follow: its top slides
// off-screen (in-app, under the native nav bar). Mirror the visual viewport's
// box onto :root so 06_mobile.css can pin the modal wrap to what is actually
// visible.
//
// `trackHeight` is off in-app: there the native bridge reserves the keyboard
// via --zs-keyboard-inset, and the visual viewport's shrunken height would
// count it twice. The pan offset is tracked in both contexts.
export function installVisualViewportVars({ trackHeight }: { trackHeight: boolean }) {
    const viewport = window.visualViewport;
    if (!viewport) return;

    const root = document.documentElement.style;
    let frame = 0;
    const apply = () => {
        frame = 0;
        // Only pin at 1x. Zoomed in, the wrap would follow the zoomed box
        // vertically but not horizontally, squeezing the modal instead of
        // letting the user pan it; fall back to the layout viewport.
        if (Math.abs(viewport.scale - 1) < 0.01) {
            root.setProperty('--zs-vv-top', `${viewport.offsetTop}px`);
            if (trackHeight) root.setProperty('--zs-vv-height', `${viewport.height}px`);
        } else {
            root.removeProperty('--zs-vv-top');
            root.removeProperty('--zs-vv-height');
        }
    };
    const schedule = () => {
        if (!frame) frame = requestAnimationFrame(apply);
    };

    viewport.addEventListener('resize', schedule);
    viewport.addEventListener('scroll', schedule);
    apply();
}
